import cn from 'classnames';
import type { ReactNode } from 'react';
import styles from './modal-scrollable-content.module.css';
import { ScrollableContentFooter } from './scrollable-content-footer';
import type { ScrollableContentFooterProperties } from './scrollable-content-footer';
import { ScrollableContentHeader } from './scrollable-content-header';
import type { ScrollableContentHeaderProperties } from './scrollable-content-header';

export type ModalScrollableContentProperties = {
  children?: ReactNode;
  className?: string;
  paddingBottom?: boolean;
  paddingTop?: boolean;
};

const ModalScrollableContent = ({
  children,
  className,
  paddingBottom = true,
  paddingTop = true,
}: ModalScrollableContentProperties) => (
  <div
    className={cn(className, styles['modal-scrollable'], {
      [styles['modal-scrollable--padding-bottom-0'] ?? '']: !paddingBottom,
      [styles['modal-scrollable--padding-top-0'] ?? '']: !paddingTop,
    })}
  >
    {children}
  </div>
);

ModalScrollableContent.Footer = function ({ className, ...rest }: ScrollableContentFooterProperties) {
  return <ScrollableContentFooter className={cn(className, styles['modal-scrollable--item-sticky'])} {...rest} />;
};
ModalScrollableContent.Header = function ({ className, ...rest }: ScrollableContentHeaderProperties) {
  return <ScrollableContentHeader className={cn(className, styles['modal-scrollable--item-sticky'])} {...rest} />;
};

export default ModalScrollableContent;
